import color from 'string-to-color'

const memoized = {}

export default function stringToColour(str) {
	if (!str) return 'rgb(0,0,0)'
	if (memoized[str]) return memoized[str]
	return (memoized[str] = color(str))
}
